import { render, staticRenderFns } from "./ReviewsCategoriesHeatmapHeader.vue?vue&type=template&id=0fbd496b&scoped=true&"
import script from "./ReviewsCategoriesHeatmapHeader.vue?vue&type=script&lang=js&"
export * from "./ReviewsCategoriesHeatmapHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsCategoriesHeatmapHeader.vue?vue&type=style&index=0&id=0fbd496b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd496b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
